import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../CustomButton';
import { formatVehicleName, formatGroup, formatChannelStatus, formatOnlineStatus } from '../../../helpers/tablesFuncHelpers';
import '../../../common/MobileGridCards.sass';

const ChannelStatusMobileCard = ({ row, editVehicle }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const nameLabel = formatVehicleName(row.device_id, row);

	const baseData = [
		{ label: t('Group'), value: formatGroup(row.groups, row) },
		{ label: t(('Channel Status').replace(/\s/g, '_')), value: formatChannelStatus(row.channel_status, row) },
		{ label: t(('Device ID').replace(/\s/g, '_')), value: row.device_id },
	];

	const statusValue = formatOnlineStatus(row.ads_online, row, true);

	return (
		<Card className="mobile-grid-card">
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						<CustomButton variant="link" onClick={(e) => editVehicle(e, row.device_id)}>{nameLabel}</CustomButton>
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{(value === undefined || value === null || value === '') ? 'N/A' : value}</span>
							</div>
						))}
					</div>
					<div className="mobile-card-status">{statusValue}</div>
				</div>
			</Card.Body>
		</Card>
	);
};

export default ChannelStatusMobileCard;
